// src/components/trading/AccountHeader.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TradingAccount } from '../../types/trading';

interface Tab {
  id: string;
  label: string;
}

interface AccountHeaderProps {
  account: TradingAccount;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  tabs: Tab[];
}

const AccountHeader: React.FC<AccountHeaderProps> = ({ 
  account, 
  activeTab, 
  setActiveTab,
  tabs
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <button
                onClick={() => navigate('/dashboard')}
                className="mr-4 text-gray-400 hover:text-gray-500"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
              </button>
              <div>
                <h1 className="text-lg font-medium text-gray-900">
                  {account.accountName}
                </h1>
                <p className="mt-1 text-sm text-gray-500">
                  {account.brokerType} - {account.server}
                </p>
              </div>
          </div>
        </div>
        
        {/* Tabs */}
          <div className="mt-6">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                  className={`${
                  activeTab === tab.id
                    ? 'border-t1blue text-t1blue'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
              >
                  {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
      </div>
    </div>
  );
};

export default AccountHeader;